import { render, staticRenderFns } from "./key.vue?vue&type=template&id=66713418&"
import script from "./key.vue?vue&type=script&lang=js&"
export * from "./key.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports